export const LOADING_MESSAGE = 'Загрузка...';
export const NO_OPTIONS_MESSAGE = 'Список пуст';
